import { createContext, useContext, useState, useCallback } from 'react';

const AbortControllerContext = createContext();

export const AbortControllerProvider = ({ children }) => {
  const [abortController, setAbortController] = useState(new AbortController());

  const createNewAbortController = useCallback(() => {
    const newAbortController = new AbortController();
    setAbortController(newAbortController);
    return newAbortController;
  }, []);

  const abort = useCallback(() => {
    abortController.abort();
  }, [abortController]);

  return (
    <AbortControllerContext.Provider value={{ createNewAbortController, abort }}>
      {children}
    </AbortControllerContext.Provider>
  );
};

export const useAbortController = () => {
  const context = useContext(AbortControllerContext);

  if (!context) {
    const fallbackController = new AbortController();
    return {
      createNewAbortController: () => fallbackController,
      abort: () => fallbackController.abort(),
    };
  }

  return context;
};
